export { Tile } from './Tile'
export type {
  InteractableTileProps as LegacyInteractableTileProps,
  LinkTileProps as LegacyLinkTileProps,
  SelectableTileProps as LegacySelectableTileProps,
  TileProps as LegacyTileProps,
} from './Tile.types'
